import {
  InstagramLogo,
  // FacebookLogo,
  Butterfly,
  // TiktokLogo,
} from '@phosphor-icons/react';
import { ExternalLink } from 'shared/types';
import { ICON_SIZE } from '../constants/common';

export type SocialMedia = 'instagram' | 'bluesky' 

export const SOCIALS = [ 'instagram', 'bluesky']

export const SOCIALS_MAP: Record<SocialMedia, ExternalLink> = {
  instagram: {
    icon: <InstagramLogo size={ICON_SIZE} />,
    label: 'Instagram',
    href: 'https://www.instagram.com/mmampodofficial',
  },
  // facebook: {
  //   icon: <FacebookLogo size={ICON_SIZE} />,
  //   label: 'Facebook',
  //   href: 'https://www.facebook.com/',
  // },
  bluesky: {
    icon: <Butterfly size={ICON_SIZE} />,
    label: 'Bluesky',
    href: 'https://bsky.app/profile/mmampod.bsky.social',
  },
};